<template>
  <div>
    <list-filters
      :tahun-filter.sync="tahunFilter"
      :bulan-filter.sync="bulanFilter"
      :kanwil-filter.sync="kanwilFilter"
      :kategori-filter.sync="kategoriFilter"
      :status-filter.sync="statusFilter"
      :tahunOptions="tahunOptions.options"
      :bulanOptions="bulanOptions.options"
      :kanwilOptions="kanwilOptions.options"
      :kategoriJenisTiketOptions="kategoriJenisTiketOptions.options"
      :statusTiketOptions="statusTiketOptions.options"
    />

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button variant="primary" @click="exportExcel">
                <span class="text-nowrap">Export Excel</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchDatas"
        responsive
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Menampilkan {{ dataMeta.from }} per {{ dataMeta.to }} dari {{ dataMeta.of }} data
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  getKanwil,
  exportExcelLaporanBerdasarkanStatus,
  getKategoriJenisTiket,
  deleteJenisTiket,
  getStatusTiketAll,
} from '@/connection-api/master'
import { getAllTiket } from '@/connection-api/tiket'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/connection-api/report-list-status/storeModule'
import useList from '@/connection-api/report-list-status/list'
import listFilters from './ListFilters.vue'

export default {
  components: {
    listFilters,

    BCard,
    BRow,
    BCol,
    // BFormInput,
    BTable,
    // BMedia,
    // BAvatar,
    // BLink,
    // BDropdown,
    // BDropdownItem,
    BPagination,
    BButton,
    vSelect,
  },
  data() {
    return {
      tahunOptions: {
        selected: 'id',
        options: [{ value: null, label: 'Pilih Tahun' }],
      },
      bulanOptions: {
        selected: 'id',
        options: [
          { value: null, label: 'Pilih Bulan' },
          { value: '01', label: 'Januari' },
          { value: '02', label: 'Februari' },
          { value: '03', label: 'Maret' },
          { value: '04', label: 'April' },
          { value: '05', label: 'Mei' },
          { value: '06', label: 'Juni' },
          { value: '07', label: 'Juli' },
          { value: '08', label: 'Agustus' },
          { value: '09', label: 'September' },
          { value: '10', label: 'Oktober' },
          { value: '11', label: 'November' },
          { value: '12', label: 'Desember' },
        ],
      },
      kanwilOptions: {
        selected: 'id',
        options: [{ value: null, label: 'Pilih Semua' }],
      },
      kategoriJenisTiketOptions: {
        selected: 'id',
        options: [{ value: null, label: '--Pilih Kategori --' }],
      },
      statusTiketOptions: {
        selected: 'id',
        options: [{ value: null, label: 'Semua' }],
      },
      searchId: 0,
    }
  },
  async mounted() {
    const responseKanwilOptions = await getKanwil()
    this.mappingSelectOption(responseKanwilOptions.data, this.kanwilOptions.options)

    const responseTahunOptions = await getAllTiket(1, { groupBy: 'tahun' })
    this.mappingSelectOptionByTahun(responseTahunOptions.data.data, this.tahunOptions.options)

    const response = await getKategoriJenisTiket()
    this.mappingSelectOptionAdd(response.data, this.kategoriJenisTiketOptions.options)

    const responseStatusTiket = await getStatusTiketAll()
    this.mappingSelectOptionAdd(responseStatusTiket.data, this.statusTiketOptions.options)
  },
  methods: {
    async emitKota(provinsiId) {
      this.kotaOptions = {
        selected: 'id',
        options: [{ value: null, label: 'Pilih Kota' }],
      }
      // const responseKota = await getKota(provinsiId)
      // this.mappingSelectOption(responseKota.data, this.kotaOptions.options)
    },
    async exportExcel() {
      // console.log(this.kategoriFilter)
      const result = await exportExcelLaporanBerdasarkanStatus({
        q: this.searchQuery,
        tahun_filter: this.tahunFilter,
        bulan_filter: this.bulanFilter,
        kanwil_filter: this.kanwilFilter,
        kategori_filter: this.kategoriFilter,
        status_filter: this.statusFilter,
      })
      const url = window.URL.createObjectURL(new Blob([result.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'laporan_status.xls')
      document.body.appendChild(link)
      link.click()
      // console.log(url)
    },
    async exportExcelOld() {
      store
        .dispatch('laporan-status/fetchDatasExcel', {
          q: this.searchQuery,
          tahun_filter: this.tahunFilter,
          bulan_filter: this.bulanFilter,
          kanwil_filter: this.kanwilFilter,
          kategori_filter: this.kategoriFilter,
          status_filter: this.statusFilter,
        })
        .then(response => {
          // this.makeToast('success', 'Simpan Data Jenis Kegiatan Berhasil Dilakukan')
          // const { data, total } = response.data
          const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'laporan_status.xls')
          document.body.appendChild(link)
          link.click()
          // console.log(url)
        })
        .catch(error => {
          // console.log(error)
        })
    },
    mappingSelectOptionByTahun(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.tahun,
            value: element.tahun,
          })
        })
      }
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.ids,
          })
        })
      }
    },
    mappingSelectOptionAdd(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'laporan-status'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) {
      store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(USER_APP_STORE_MODULE_NAME)
      }
    })

    const isAddNewUserSidebarActive = ref(false)

    const {
      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      tahunFilter,
      bulanFilter,
      kanwilFilter,
      kategoriFilter,
      statusFilter,
    } = useList()

    return {
      // Sidebar
      isAddNewUserSidebarActive,

      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      tahunFilter,
      bulanFilter,
      kanwilFilter,
      statusFilter,
      kategoriFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
